export default __webpack_public_path__ + "static/blogBG3-4599db8a2bfcf004dcdd946736239092.svg";